import React from 'react';
import simuladores from '../data/simuladores';
import SimuladorCard from '../components/Cards/SimuladorCard';

const Simuladores = () => {
  return (
    <div style={{ padding: '2rem',marginTop:'5%', }}>
      <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
        {simuladores.map((sim, index) => (
          <SimuladorCard
            key={index}
            title={sim.titulo}
            description={sim.descripcion}
            image={sim.imagen}
            url={sim.url}
            buttonText={sim.botonTexto}
          />
        ))}
      </div>
    </div>
  );
};

export default Simuladores;
